const setData = 'setData';
const modalRightCountIncrease = 'modalRightCountIncrease';
const setTagInsGroup = 'setTagInsGroup'
const getTagsCache = 'getTagsCache';
const setTagsCache = 'setTagsCache';

export {
	setData, // 设置 state
	modalRightCountIncrease, // 设置删除自动增加
	setTagInsGroup, // 设置打标签页面时的源
	getTagsCache, // 从 localStorage 中获得存储的标签缓存
	setTagsCache, // 设置 localStorage 中标签的缓存
};
